import 'ui-theme/components/sections-navbar/js/sections-navbar';
const sidebarSections = UX.sidebarSections;
let shouldScroll = true;
sidebarSections.init = function () {
    if (sidebarSections.$scrollPoints.length || UX.sidebarSections.$block.children().length) {
        sidebarSections.initSections();
        sidebarSections.set.selectedSection();
        sidebarSections.controller();
        if (!sidebarSections.isMobile) {
            sidebarSections.sectionTitleClick();
        }
    } else {
        if ($('.sections-navigation').find('.article-tabs-block-container').length === 0) {
            $('.sections-navigation').hide();
        }
    }
    sidebarSections.moveToSection();
};

sidebarSections.moveToSection = function () {
    window.addEventListener('wheel', () => (shouldScroll = false));
    const observer = new MutationObserver(sidebarSections.observeDocument);
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
    });
    sidebarSections.observeDocument(observer);
};

sidebarSections.observeDocument = observer => {
    const links = document.querySelectorAll('#sectionsNavigation_Pop a');
    if (links.length) {
        links.forEach(link => link.addEventListener('click', sidebarSections.handleLinkClick));
        observer.disconnect();
    }
};

sidebarSections.handleLinkClick = e => {
    const href = e.target.getAttribute('href');
    if (href && href.length > 1 && href.startsWith('#')) {
        e.preventDefault();
        e.stopPropagation();
        shouldScroll = true;

        const id = href.substring(1);
        sidebarSections.scrollToElement(id);

        const resizeObserver = new ResizeObserver(entries => {
            shouldScroll && sidebarSections.scrollToElement(id);
        });
        resizeObserver.observe(document.body);
    }
};

sidebarSections.scrollToElement = id => {
    const element = document.getElementById(id);
    if (element) {
        const scrollHeight = element.getBoundingClientRect().top + window.scrollY;
        const headerHeight = document.querySelector('header.header').offsetHeight;
        window.scrollTo({
            top: scrollHeight - headerHeight,
            behavior: 'smooth',
        });
    }
};
